// extracted by mini-css-extract-plugin
export default {"container":"DD-z","vocBtn":"ED-z","disabled":"FD-z"};